import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  CreateFreebetsFormContext,
  CreateFreebetsFormState,
  createFreebetsFormStateDefault,
  createFreebetsSchemaDefault,
} from '@Forms/freebets/CreateFreebetsFormContext';

export const CreateFreebetsFormProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<CreateFreebetsFormState>>>(
    createFreebetsSchemaDefault
  );
  const methods = useForm({
    defaultValues: createFreebetsFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <CreateFreebetsFormContext.Provider value={value}>
      {children}
    </CreateFreebetsFormContext.Provider>
  );
};
